export default __webpack_public_path__ + "static/media/coxa-logo.85be2656.png";